import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

import mainStore from "@main/vuex";
import contol from '@/modules/contol/vuex'
import news from '@/modules/user-center/news/vuex'
Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    main: mainStore,
    contol,
    news
  },
  plugins: [
    createPersistedState({
      storage: window.localStorage,
      reducer: state => ({
        default: {
          //userInfo: state.default.userInfo,
          // menus: state.default.menus,
          // menuTabs: state.default.menuTabs,
          // selectedTab: state.default.selectedTab,
          // noMenuTabsMap: state.default.noMenuTabsMap,
          // allAreas: state.default.allAreas
        }
      })
    })
  ]
});

export default store;



// WEBPACK FOOTER //
// ./src/store.js